import { Popover, Transition } from "@headlessui/react";
import React from "react";

interface DropdownProps extends React.ComponentPropsWithoutRef<typeof Popover> {
  title?: string | React.ReactNode;
  children: React.ReactNode;
}

export const Dropdown = ({ title, children }: DropdownProps) => {
  return (
    <Popover>
      <Popover.Button
        className={"bg-none outline-none border-none cursor-pointer"}
      >
        {title}
      </Popover.Button>
      <Transition
        as={React.Fragment}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Popover.Panel className="bg-white border border-gray-300 absolute z-10 cursor-pointer right-0 md:right-auto">
          {children}
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default Dropdown;
